import { Box, Flex, Text, HStack, VStack, Button } from "@chakra-ui/react";
import { FaFileExcel, FaDesktop, FaPlus, FaUser, FaTrash } from "react-icons/fa";

interface AlterationStatsProps {
  onOpenAlterations: () => void;
  onOpenDeletions: () => void;
  excelPercentage: number;
  systemPercentage: number;
  excelCount?: number;
  systemCount?: number;
}

const AlterationStats = ({
  excelPercentage,
  systemPercentage,
  excelCount,
  systemCount,
  onOpenAlterations,
  onOpenDeletions,
}: AlterationStatsProps) => {
  return (
    <Box
      w="100%"
      p="24px"
      backgroundColor="white"
      borderRadius="8px"
      mb="16px"
      boxShadow="sm"
    >
      <Text fontSize="lg" fontWeight="semibold" mb="16px">
        Origem das Alterações
      </Text>

      <VStack spacing="16px" align="stretch">
        {/* Excel Line */}
        <Box>
          <HStack justify="space-between" mb="8px">
            <HStack spacing="8px">
              <FaFileExcel color="#1C6C3F" size={20} />
              <Text fontWeight="medium">Excel</Text>
            </HStack>
            <HStack spacing="12px">
              {excelCount !== undefined && (
                <Text fontSize="sm" color="gray.600">
                  {excelCount} alterações
                </Text>
              )}
              <Text fontWeight="bold" color="#1C6C3F">
                {excelPercentage?.toFixed(1)}%
              </Text>
            </HStack>
          </HStack>
          <Box
            w="100%"
            h="24px"
            backgroundColor="gray.100"
            borderRadius="12px"
            overflow="hidden"
          >
            <Box
              h="100%"
              w={`${excelPercentage}%`}
              backgroundColor="#1C6C3F"
              borderRadius="12px"
              transition="width 0.5s ease"
            />
          </Box>
        </Box>

        {/* System Line */}
        <Box>
          <HStack justify="space-between" mb="8px">
            <HStack spacing="8px">
              <FaDesktop color="var(--icon-color)" size={20} />
              <Text fontWeight="medium">Sistema</Text>
            </HStack>
            <HStack spacing="12px">
              {systemCount !== undefined && (
                <Text fontSize="sm" color="gray.600">
                  {systemCount} alterações
                </Text>
              )}
              <Text fontWeight="bold" color="var(--icon-color)">
                {systemPercentage.toFixed(1)}%
              </Text>
            </HStack>
          </HStack>
          <Box
            w="100%"
            h="24px"
            backgroundColor="gray.100"
            borderRadius="12px"
            overflow="hidden"
          >
            <Box
              h="100%"
              w={`${systemPercentage}%`}
              backgroundColor="var(--icon-color)"
              borderRadius="12px"
              transition="width 0.5s ease"
            />
          </Box>
        </Box>
      </VStack>
      <Button
        mt="32px"
        color="white"
        borderRadius="4px"
        backgroundColor="var(--icon-color)"
        onClick={() => onOpenAlterations()}
      >
        <Flex justifyContent="center" alignItems="center" gap="8px">
          <FaUser color="white" /> Alterações por usuário
        </Flex>
      </Button>

      <Button
        mt="32px"
        ml="16px"
        variant="outline"
        borderColor="var(--icon-color)"
        color="var(--icon-color)"
        onClick={onOpenDeletions}
      >

        <Flex justifyContent="center" alignItems="center" gap="8px">
          <FaTrash color="var(--icon-color)" />
          Histórico de exclusões
        </Flex>

      </Button>

    </Box>
  );
};

export default AlterationStats;
